import _moduleHelper from '@/store/modules/_moduleHelper';
import EnquiryTemplatesService from '@/api/enquiryTemplates.service';

export const NAMESPACE = 'ENQUIRY_TEMPLATES';

export const STATE = {
    ENQUIRY_TEMPLATES: 'ENQUIRY_TEMPLATES',
    PAGE: 'PAGE',
    ITEMS_PER_PAGE: 'ITEMS_PER_PAGE',
    TOTAL_ITEMS: 'TOTAL_ITEMS',
    SEARCH: 'SEARCH',
    ORDER_BY: 'ORDER_BY',
    ORDER: 'ORDER',
};

export const GETTERS = {};

export const MUTATIONS = {
    SET_ENQUIRY_TEMPLATES: 'SET_ENQUIRY_TEMPLATES',
    SET_PAGE: 'SET_PAGE',
    SET_ITEMS_PER_PAGE: 'SET_ITEMS_PER_PAGE',
    SET_TOTAL_ITEMS: 'SET_TOTAL_ITEMS',
    SET_SEARCH: 'SET_SEARCH',
    SET_ORDER_BY: 'SET_ORDER_BY',
    SET_ORDER: 'SET_ORDER',
};

export const ACTIONS = {
    GET_ENQUIRY_TEMPLATES: 'GET_ENQUIRY_TEMPLATES',
    POST_ENQUIRY_TEMPLATE: 'POST_ENQUIRY_TEMPLATE',
    PATCH_ENQUIRY_TEMPLATE: 'PATCH_ENQUIRY_TEMPLATE',
    DELETE_ENQUIRY_TEMPLATE: 'DELETE_ENQUIRY_TEMPLATE',
};

export const MODULE = {
    namespaced: true,
    state: {
        [STATE.ENQUIRY_TEMPLATES]: [],
        [STATE.PAGE]: 1,
        [STATE.ITEMS_PER_PAGE]: 10,
        [STATE.TOTAL_ITEMS]: null,
        [STATE.SEARCH]: '',
        [STATE.ORDER_BY]: 'name',
        [STATE.ORDER]: 'asc',
    },
    getters: {},
    mutations: {
        [MUTATIONS.SET_ENQUIRY_TEMPLATES]: (state, enquiryTemplates) => state[STATE.ENQUIRY_TEMPLATES] = enquiryTemplates,
        [MUTATIONS.SET_PAGE]: (state, page) => state[STATE.PAGE] = page,
        [MUTATIONS.SET_ITEMS_PER_PAGE]: (state, itemsPerPage) => state[STATE.ITEMS_PER_PAGE] = itemsPerPage,
        [MUTATIONS.SET_TOTAL_ITEMS]: (state, totalItems) => state[STATE.TOTAL_ITEMS] = totalItems,
        [MUTATIONS.SET_SEARCH]: (state, search) => state[STATE.SEARCH] = search,
        [MUTATIONS.SET_ORDER_BY]: (state, orderBy) => state[STATE.ORDER_BY] = orderBy,
        [MUTATIONS.SET_ORDER]: (state, order) => state[STATE.ORDER] = order,
    },
    actions: {
        async [ACTIONS.GET_ENQUIRY_TEMPLATES]({ state, commit }) {
            const { data } = await EnquiryTemplatesService.getEnquiryTemplates(
                state[STATE.SEARCH],
                state[STATE.PAGE],
                state[STATE.ITEMS_PER_PAGE],
                state[STATE.ORDER_BY],
                state[STATE.ORDER],
            );
            commit(MUTATIONS.SET_ENQUIRY_TEMPLATES, data['hydra:member']);
            commit(MUTATIONS.SET_TOTAL_ITEMS, data['hydra:totalItems']);
        },
        async [ACTIONS.POST_ENQUIRY_TEMPLATE]({ dispatch }, enquiryTemplate) {
            const { data } = await EnquiryTemplatesService.postEnquiryTemplate(enquiryTemplate);
            await dispatch(ACTIONS.GET_ENQUIRY_TEMPLATES);

            return data;
        },
        async [ACTIONS.PATCH_ENQUIRY_TEMPLATE]({ dispatch }, enquiryTemplate) {
            const { data } = await EnquiryTemplatesService.patchEnquiryTemplate(enquiryTemplate);
            await dispatch(ACTIONS.GET_ENQUIRY_TEMPLATES);

            return data;
        },
        async [ACTIONS.DELETE_ENQUIRY_TEMPLATE]({ dispatch }, enquiryTemplate) {
            await EnquiryTemplatesService.deleteEnquiryTemplate(enquiryTemplate);
            await dispatch(ACTIONS.GET_ENQUIRY_TEMPLATES);
        },
    },
};

export default {
    NAMESPACE,
    STATE,
    GETTERS,
    MUTATIONS,
    ACTIONS,
    MODULE,
    ..._moduleHelper(NAMESPACE),
};
